import * as yup from "yup";

export const IGNORE_ERROR = "IGNORE";

export const FLEET_VEHICLE_CONTRACT_SALE_EDIT_FORM_SCHEMA = yup
  .object()
  .shape({
    offerSaleId: yup
      .string()
      .nullable()
      .required("Molimo Vas da odaberete ponudu"),

    contractNumber: yup
      .string()
      .required(
        "Broj ugovora je obavezan podatak. Molimo Vas da kontaktirate administratora"
      ),

    contractDate: yup
      .string()
      .required("Datum ugovora je obavezan podatak"),

    contractSaleTemplateId: yup
      .string()
      .required("Molimo Vas da odaberete predložak ugovora"),

    // --- SELLER ---
    sellerCompanyName: yup
      .string()
      .required("Naziv prodavatelja je obavezan podatak"),

    sellerHeadquartersAddress: yup
      .string()
      .required("Adresa sjedišta prodavatelja je obavezan podatak"),

    sellerPhoneNumber: yup
      .string()
      .required("Telefon prodavatelja je obavezan podatak"),

    sellerPersonalIdentificationNumber: yup
      .string()
      .required("OIB prodavatelja je obavezan podatak"),

    sellerSalesPersonName: yup
      .string()
      .required("Ime prodajne osobe je obavezan podatak"),

    sellerTransactionAccountNumber: yup
      .string()
      .required("Broj transakcijskog računa prodavatelja je obavezan podatak"),

    // --- BUYER ---
    buyerName: yup
      .string()
      .required("Ime i prezime / naziv kupca je obavezan podatak"),

    buyerAddress: yup
      .string()
      .required("Adresa kupca je obavezan podatak"),

    buyerPersonalIdentificationNumber: yup
      .string()
      .required("OIB kupca je obavezan podatak"),

    buyerPhoneNumber: yup
      .string()
      .nullable(),

    buyerMobilePhoneNumber: yup
      .string()
      .nullable(),

    buyerEmail: yup
      .string()
      .email("Unesite ispravnu email adresu")
      .required("Email kupca je obavezan podatak"),

    buyerAuthorizedRepresentativeName: yup
      .string()
      .required("Ovlaštena osoba kupca je obavezan podatak"),

    // --- CONTRACT DETAILS ---
    // depositAmount: yup
    //   .number()
    //   .typeError("Iznos pologa mora biti broj")
    //   .min(0, "Iznos pologa ne može biti negativan")
    //   .required("Iznos pologa je obavezan podatak"),

    deliveryTime: yup
      .string()
      .required("Rok isporuke je obavezan podatak"),

    placeOfVehicleDelivery: yup
      .string()
      .required("Mjesto isporuke vozila je obavezan podatak"),
  })
  .test(
    "buyer-phone-or-mobile-required",
    "Potrebno je unijeti telefon ili mobitel kupca",
    function (value) {
      const phone = value?.buyerPhoneNumber?.trim();
      const mobile = value?.buyerMobilePhoneNumber?.trim();

      if (phone || mobile) {
        return true;
      }

      // 👇 OVO JE KLJUČNO
      return this.createError({
        path: "buyerMobilePhoneNumber", // ili "buyerMobilePhoneNumber"
        message: "Potrebno je unijeti telefon ili mobitel kupca",
      });
    }
  );
